import './style.scss';
import companyFilter from './js/companyFilter';

import { executeOnDocumentReady } from '../../../utils';

executeOnDocumentReady(() => {
	companyFilter();
});
